export const gradeColorJson: Record<string, string> = {
  NEWBIE: '#F198D3',
  BRONZE: '#D78E93',
  SILVER: '#779DD1',
  GOLD: '#E0AA1D',
  VIP: '#FA6EE3',
};

export const PAYMENT_POPUP_VIEW_QUERY_KEY = {
  payment: 'payment',
};
